import { TableRow, TableHeadCell } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledTableRow = styled(TableRow) `
  height: 0 !important;
`;
export const StyledTableHeadCell = styled(TableHeadCell) `
  border: none !important;
`;
